export default "__VITE_ASSET__HNSaNmlj__"